<template>
  <div>
    <div v-if="!isDataAvailable">
      <div v-if="!isRecording">
        <h1>{{ getText('record_title') }}</h1>
        <p>
          {{ getText('record_text') }}
          <span
            v-if="this.$variables.level == 'easy'"
            class="difficulty"
          >{{ getText('difficulty_easy') }}</span>
          <span
            v-if="this.$variables.level == 'medium'"
            class="difficulty"
          >{{ getText('difficulty_medium') }}</span>
          <span
            v-if="this.$variables.level == 'hard'"
            class="difficulty"
          >{{ getText('difficulty_hard') }}</span>
          |
          <router-link :to="'/difficulty/' + this.$route.params.lang">
            <span class="change">{{ getText('record_back') }}</span>
          </router-link>
        </p>
      </div>
      <div v-if="isRecording" style="margin-top: 110px">
        <h1>{{ getText('record_go') }}</h1>
      </div>
      <div class="w-3/5 ml-auto mr-auto" id="timings" v-html="getTimingsTexts(100)"></div>
      <div class="w-2/5 ml-auto mr-auto mt-5 text-center" v-if="!isRecording">
        <button
          class="py-3 px-10 rounded-full w-full outlined-button"
          @click="play"
          :disabled="isPlaying || isRecording || isCountingDown"
          :class="{ 'opacity-50 cursor-not-allowed': isPlaying || isRecording || isCountingDown }"
        >{{ getText('record_play_again') }}</button>
        <br />
        <br />
        <button
          class="bg-white py-3 px-10 rounded-full w-full shadow-md"
          @click="record"
          :disabled="isPlaying || isRecording || isCountingDown"
          :class="{ 'opacity-50 cursor-not-allowed': isPlaying || isRecording || isCountingDown }"
        >{{ recordButtonTitle }}</button>
      </div>
      <div class="ml-auto mr-auto mt-5" style="width: 150px" v-if="isRecording">
        <radial-progress-bar
          :diameter="150"
          :completed-steps="recordCompletedSteps"
          :total-steps="recordSteps"
          :animate-speed="100"
          start-color="#544B45"
          stop-color="#544B45"
          inner-stroke-color="#E4E1DB"
        >
          <img src="images/mic.svg" class="inline-block" style="width: 62px" />
        </radial-progress-bar>
      </div>
    </div>
    <div v-if="isDataAvailable">
      <div
        class="ml-auto mr-auto rounded-full"
        style="width: 400px; border: 15px solid #544b45; margin-top: 120px; text-align: center; padding: 50px"
      >
        <img src="images/mic.svg" class="inline-block" style="width: 200px" />
      </div>
      <div class="w-3/5 ml-auto mr-auto flex" style="margin-top: 80px">
        <button
          class="py-3 px-10 rounded-full w-full outlined-button mr-2"
          @click="replay"
          :disabled="isPlaying"
          :class="{ 'opacity-50 cursor-not-allowed': isPlaying }"
        >{{ getText('button_play_mine') }}</button>
        <button
          class="py-3 px-10 rounded-full w-full outlined-button ml-2"
          @click="isDataAvailable = false"
        >{{ getText('button_repeat') }}</button>
      </div>
      <div class="w-3/5 ml-auto mr-auto mt-10">
        <button
          class="bg-white py-3 px-10 rounded-full w-full shadow-md"
          @click="nextStep"
        >{{ getText('button_save') }}</button>
      </div>
    </div>

    <modal
      name="countdown-modal"
      :width="400"
      :height="400"
      styles="background: transparent; box-shadow: none"
    >
      <div id="countdown-dialog">
        <radial-progress-bar
          :diameter="400"
          :completed-steps="countdownStep"
          :total-steps="2"
          :animate-speed="1000"
          start-color="#544B45"
          stop-color="#544B45"
          inner-stroke-color="#E4E1DB"
        >{{ countdownStep + 1 }}</radial-progress-bar>
      </div>
    </modal>

    <audio id="difficultyAudio">
      <source src="sounds/easy_F.mp3" type="audio/mp3" />
    </audio>

    <audio id="replayAudio">
      <source src="sounds/easy_F.mp3" type="audio/mp3" />
    </audio>
  </div>
</template>

<style scoped>
h1 {
  font-family: FoundryWilsonMedium;
  font-size: 66px;
  text-transform: uppercase;
  width: 1100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 72px;
  text-align: center;
}

p {
  font-family: FoundryWilsonNormal;
  font-size: 28px;
  letter-spacing: 1px;
  width: 1100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 72px;
  text-align: center;
}

.difficulty {
  font-family: FoundryWilsonItalic;
  font-size: 28px;
  letter-spacing: 2px;
}

.change {
  font-family: VerlagBold;
  letter-spacing: 2px;
  color: #544b45;
  text-decoration: underline;
  text-transform: uppercase;
}

.outlined-button {
  border: 2px solid #544b45;
}

#timings {
  height: 300px;
  color: #00692f;
  font-family: FoundryWilsonNormal;
  font-size: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

#countdown-dialog {
  font-size: 250px;
}
</style>

<script>
import RadialProgressBar from "vue-radial-progress";

export default {
  name: "Record",
  components: {
    RadialProgressBar
  },
  data: () => {
    return {
      isPlaying: false,
      isCountingDown: false,
      isRecording: false,
      isDataAvailable: false,
      recordButtonTitle: "-",
      recordedData: null,
      recordSteps: 0,
      recordCompletedSteps: 0,
      countdownStep: 3
    };
  },
  methods: {
    getText(key) {
      return this.$settings.interface[key][this.$route.params.lang];
    },

    getTimings() {
      return this.$settings.timings[
        this.$variables.level + "_" + this.$variables.gender
      ];
    },

    getTimingsTexts(highlight) {
      let timings = this.getTimings();
      let result = '<span style="color: #B6C9B8">';
      if (highlight) {
        result += '<span style="color: #00692F">';
      }
      timings.forEach((t, i) => {
        result += t.word + " ";
        if (i == highlight) {
          result += "</span>";
        }
      });
      result += "</span>";
      return result;
    },

    play() {
      let audio = document.getElementById("difficultyAudio");
      audio.src =
        "sounds/" +
        this.$variables.level +
        "_" +
        this.$variables.gender +
        ".mp3";
      audio.play();
      audio.addEventListener("ended", () => {
        this.isPlaying = false;
      });
      this.isPlaying = true;
    },

    record() {
      this.isCountingDown = true;
      navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
        let mediaRecorder = new MediaRecorder(stream);
        mediaRecorder.ondataavailable = e => {
          this.recordedData = e.data;
          let blob = new Blob([this.recordedData], { type: "audio/mpeg-3" });
          let url = URL.createObjectURL(blob);
          let replayAudio = document.getElementById("replayAudio");
          this.$variables.recording = url;
          replayAudio.src = url;
          this.isDataAvailable = true;
        };

        // start countdown
        this.$modal.show("countdown-modal");
        this.countdownStep = 2;
        let countdownInterval = setInterval(() => {
          this.countdownStep--;
          if (this.countdownStep == -1) {
            clearInterval(countdownInterval);
          }
        }, 999);

        // start recording after countdown
        setTimeout(() => {
          this.isCountingDown = false;
          this.isRecording = true;

          this.$modal.hide("countdown-modal");
          mediaRecorder.start();

          const el = document.getElementById("timings");
          while (el.firstChild) {
            el.removeChild(el.lastChild);
          }

          this.recordSteps = Math.ceil(this.getTimings()[0]["timestamp"] / 100);
          this.recordCompletedSteps = 0;
          let interval = setInterval(() => {
            this.recordCompletedSteps += 1;
          }, 100);
          this.getTimings().forEach((t, i) => {
            setTimeout(() => {
              this.recordButtonTitle = this.getText("go");
              let el = document.getElementById("timings");
              if (el) {
                el.innerHTML = this.getTimingsTexts(i);
              }
              if (i == this.getTimings().length - 1) {
                this.isRecording = false;
                mediaRecorder.stop();
                this.recordButtonTitle = this.getText("button_record");
                clearInterval(interval);
              }
            }, t.timestamp);
          });
        }, 3000);
      });
    },

    replay() {
      let replayAudio = document.getElementById("replayAudio");
      replayAudio.play();
      replayAudio.addEventListener("ended", () => {
        this.isPlaying = false;
      });
      this.isPlaying = true;
    },

    nextStep() {
      this.$router.push({
        name: "photo",
        params: { lang: this.$route.params.lang }
      });
    }
  },

  mounted() {
    this.recordButtonTitle = this.getText("button_record");
  }
};
</script>

